import { Translator } from 'Translator';
import { SubOption } from 'model/Filters';

const cuisineSubOptions = [
  {
    id: 81,
    name: Translator.translate(
      'Experience.Cuisine.italian',
      {},
      true,
      'Italian',
    ),
    value: 'italian',
  },
  {
    id: 82,
    name: Translator.translate('Experience.Cuisine.greek', {}, true, 'Greek'),
    value: 'greek',
  },
  {
    id: 83,
    name: Translator.translate('Experience.Cuisine.fusion', {}, true, 'Fusion'),
    value: 'fusion',
  },
  {
    id: 85,
    name: Translator.translate('Experience.Cuisine.asian', {}, true, 'Asian'),
    value: 'asian',
  },
  {
    id: 87,
    name: Translator.translate('Experience.Cuisine.nepali', {}, true, 'Nepali'),
    value: 'Nepali',
  },
  {
    id: 89,
    name: Translator.translate('Experience.Cuisine.german', {}, true, 'German'),
    value: 'german',
  },
  {
    id: 810,
    name: Translator.translate(
      'Experience.Cuisine.mexican',
      {},
      true,
      'Mexican',
    ),
    value: 'mexican',
  },
  {
    id: 811,
    name: Translator.translate('Experience.Cuisine.raw', {}, true, 'Raw'),
    value: 'raw',
  },
  {
    id: 812,
    name: Translator.translate('Experience.Cuisine.dutch', {}, true, 'Dutch'),
    value: 'dutch',
  },
  {
    id: 813,
    name: Translator.translate(
      'Experience.Cuisine.indonesian',
      {},
      true,
      'Indonesian',
    ),
    value: 'indonesian',
  },
] as SubOption[];

export default cuisineSubOptions;
